import { influencer, influencerQueries } from '@round/api';
import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query';
import { useCreatorImages } from './useCreatorImages';

const options = influencerQueries.creatorExplore.options.infinite;
const keys = influencerQueries.creatorExplore.keys;

type Params = Omit<influencer.GetCreatorExploreParams, 'page'>;

type Config = Pick<ReturnType<typeof options>, 'enabled' | 'placeholderData'>;

export function useCreatorExplore(params: Params, config?: Config) {
    const queryClient = useQueryClient();

    const query = useInfiniteQuery({ ...options(params), ...config });

    const { getCreatorImages, getAreCreatorImagesLoading } = useCreatorImages(
        query.data?.pages.map((page) => page.results) ?? []
    );

    return {
        data: query.data?.pages.flatMap((page) => page.results) ?? [],
        count: query.data?.pages[0]?.count,
        status: query.status,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        isFetchingNextPage: query.isFetchingNextPage,
        hasError: query.isError,
        hasNextPage: query.hasNextPage,
        fetchNextPage: query.fetchNextPage,

        getCreatorImages,
        getAreCreatorImagesLoading,
        invalidate: () => {
            queryClient.invalidateQueries({ queryKey: keys.infiniteLists() });
            queryClient.invalidateQueries({ queryKey: keys.lists() });
        },
    };
}
